import React from 'react'
import PropTypes from 'prop-types'
import { Columns } from '@deseretbook/react-ui'
import { BraintreeInput } from './'

/**
 * Generic BraintreeInput fields to be used as part of a form to collect
 * payment information. Should be used as part of some sort of `PaymentFormManager`
 * and a `Form` component.
 */
const PaymentFormFields = ({
  fields,
  isFetchingData,
  cardNumberId,
  expirationId,
  cvvId,
}) => (
  <Columns isMobile>
    <Columns.Column size={12}>
      <BraintreeInput
        field={fields.number}
        label="Card Number"
        id={cardNumberId}
        isLoading={isFetchingData}
      />
    </Columns.Column>
    <Columns.Column size={6}>
      <BraintreeInput
        field={fields.expirationDate}
        label="Expiration"
        id={expirationId}
        isLoading={isFetchingData}
      />
    </Columns.Column>
    <Columns.Column size={6}>
      <BraintreeInput
        field={fields.cvv}
        label="Security Code"
        id={cvvId}
        isLoading={isFetchingData}
      />
    </Columns.Column>
  </Columns>
)

PaymentFormFields.propTypes = {
  fields: PropTypes.object,
  isFetchingData: PropTypes.bool,
  cardNumberId: PropTypes.string,
  expirationId: PropTypes.string,
  cvvId: PropTypes.string,
}

PaymentFormFields.defaultProps = {
  fields: {},
  isFetchingData: false,
  cardNumberId: '',
  expirationId: '',
  cvvId: '',
}

export default PaymentFormFields
